import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'

import {TEST_IDS} from '../constants/test-ids'
import {VALUES} from '../constants/values'
import styles from './IssueBodyLoading.module.css'

export const IssueBodyLoading = () => {
  return (
    <div data-testid={TEST_IDS.bodyLoading} className={styles.IssueBodyLoadingContainer}>
      {[...Array(VALUES.bodyLoadingSkeletonCount)].map((_, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <IssuesLoadingSkeleton key={index} height="sm" width="random" />
      ))}
    </div>
  )
}
